const appConfig = window.__APP_CONFIG__ ?? {};

function requireConfig(key) {
  const value = appConfig[key];
  if (!value) {
    throw new Error(`config.js 의 window.__APP_CONFIG__ 에 ${key} 가 없습니다`);
  }
  return value;
}

export const API_BASE_URL = requireConfig('API_BASE_URL');
export const ADMIN_URL = requireConfig('ADMIN_URL');
